import styled from 'styled-components';
import { spacing, colors } from 'ui/theme';

const SharedTextStyling = `
  display: inline-block;
  color: ${colors.grey50};
`;

export const Wrapper = styled.div`
  ${SharedTextStyling}
  margin-right: ${spacing.half};
  &:after {
    padding-left: ${spacing.half};
    content: '\u00B7';
    display: inline-block;
  }
  &:hover {
    cursor: pointer;
  }
`;

export const Text = styled.p`
  ${SharedTextStyling}
`;
